import { get } from "services/actions";
import AppLayout from "components/AppLayout";
import CasaVerdeAmarela from "components/pages/CasaVerdeAmarela";
import strapiImg from "utils/strapiImg";

export default function Realiza({ appLayout, realizaPage, casaVerdeAmarela }) {
  return (
    <AppLayout data={appLayout}>
      <CasaVerdeAmarela data={casaVerdeAmarela} />
    </AppLayout>
  );
}

export async function getStaticProps() {
  const header = await get("cabecalho");
  const footer = await get("rodape");
  const receiveNews = await get("receba-novidades");
  const data = await get("a-realiza");

  // DADOS AppLayout
  const appLayout = {
    header: {
      logo: strapiImg(header.logo, "", true),
      menu: header.menu,
    },
    footer: {
      logo: strapiImg(footer.logo, "", true),
      redes: footer.redes_sociais.map(({ id, nome, link, icone }) => {
        icone = strapiImg(icone, "", true);
        return {
          id,
          nome,
          link,
          icone,
        };
      }),
      unidades: footer.unidades,
      submenus: footer.submenu,
      whatsappIcon: strapiImg(footer?.icone_whatsapp_rodape, "", true),
      openChatBot: footer?.habilitar_chatbot,
    },
  };

  // DADOS CasaVerdeAmarela
  const casaVerdeAmarela = {
    seo: {
      titulo: data.SEO.title,
      descricao: data.SEO.description,
      imagem: strapiImg(data.SEO.image, "", true),
    },
    banner: {
      titulo: "O que é o programa Minha Casa Minha Vida?",
      imagem: { url: `/images/banner_casa_verde_amarela.png` },
      logos: {
        logo_programa: { url: `/images/logo-minha-casa.png` },
        logo_caixa: { url: `/images/logo_caixa.png` },
      },
    },
    descricao: {
      texto: `É o novo programa habitacional do Governo Federal 
              que surgiu com objetivo de reformular o Minha Casa Minha Vida
              com diferenciais como as taxas de juros mais baixas para todo Brasil.  
              <br/>
              O programa Minha Casa Minha Vida reúne iniciativas habitacionais do governo
              federal para ampliar o estoque de moradias e atender as necessidades habitacionais
              da população, ajudando mais de 1 milhão de brasileiros a realizarem o sonho de comprarem
              um apartamento financiado.  
              <br />
              Fique por dentro de todos os detalhes do Minha Casa Minha Vida
              e conheça as vantagens que a Realiza pode oferecer para você conquistar seu novo lar.`,
      imagem: {
        url: "/images/descricao_image.png",
      },
    },
    vantagens: {
      titulo: "Principais vantagens do Programa Minha Casa Minha Vida",
      itens: [
        {
          backgroung_color: "#ffffff",
          titulo: "1.Subsídio do Governo",
          descricao: `É um valor pago pelo Governo Federal para te auxiliar na compra do imóvel como forma de desconto,  
                    resultando em parcelas mais baratas e um financiamento que caiba no seu bolso.  
                    <br/>
                    As faixas de renda e os valores aproximados para ganhar o subsídio variam de acordo com a renda e a região  
                    em que você quer conquistar o imóvel.`,
          cards: [],
        },
        {
          background_color: "#f4f3f3",
          titulo: "2.FGTS",
          descricao: `Você pode utilizar seu Fundo de Garantia por Tempo de Serviço (FGTS) como valor de entrada para amenizar as  
        parcelas e auxiliar na negociação de financiamento.  
                    <br/>
                    Para usar o FGTS na compra do seu apartamento, você precisa ter conhecimento de que é necessário:`,
          cards: [
            {
              imagem_card: {
                url: "/images/fgts_imagem.svg",
              },
              descricao: "Ter no mínimo 3 anos de recolhimento de FGTS.",
            },
            {
              imagem_card: {
                url: "/images/locale.svg",
              },
              descricao: "Não possuir um imóvel na mesma cidade.",
            },
            {
              imagem_card: {
                url: "/images/moedas.svg",
              },
              descricao:
                "Não ter financiamento no Sistema Financeiro de Habitação.",
            },
          ],
        },
        {
          background_color: "#ffffff",
          titulo: "3.Facilidade no financiamento:",
          descricao: `O programa Minha Casa Minha Vida permite, por exemplo, que a sua casa ou apartamento seja quitado em até 360 meses. E não só isso, tem mais facilidades do que você imagina para que conquiste o tão sonhado lar.`,
          cards: [
            {
              imagem_card: {
                url: "/images/mao.png",
              },
            },
          ],
        },
        {
          background_color: "#f4f3f3",
          titulo: "4.Utilize seu FGTS.",
          descricao: `Após uma atualização do sistema, é necessário autorização do uso do FGTS do cliente no aplicativo do FGTS ou da Caixa. Procurar ajuda dos nossos corretores especializados para conferir o passo a passo da autorização.`,
          cards: [
            {
              imagem_card: {
                url: "/images/carteira.png",
              },
            },
          ],
        },
        {
          background_color: "#ffffff",
          titulo: "5.Taxa de juros baixa:",
          descricao: `O Minha Casa Minha Vida oferece taxas de juros e valores bem abaixo dos praticados pelo mercado com intuito de facilitar a aquisição do imóvel. Podendo variar de acordo com a sua renda familiar e região que você pretende comprar seu apartamento.`,
          cards: [
            {
              imagem_card: {
                url: "/images/barras.png",
              },
            },
          ],
        },
      ],
    },
    quem_pode: {
      title: "Quem pode participar do programa?",
      background_imagem: { url: "/images/familia.png" },
      logos: {
        logo_programa: { url: `/images/logo-minha-casa.png` },
        logo_caixa: { url: `/images/logo_caixa.png` },
      },
      itens: [
        { text: "Brasileiros ou naturalizados no pais" },
        { text: "Pessoas com mais de 18 anos" },
        { text: "Se encaixa em uma das faixas de renda" },
        { text: "Ainda não adquiriu uma casa ou apartamento próprio" },
        { text: "Quem não está no Cadastro Nacional de Mutuários (CADMUT)" },
        { text: "Aquele que nunca recebeu benefício moradia do governo" },
      ],
    },
    passos: {
      titulo: "Descubra como conquistar seu próprio apê com a Realiza",
      descricao:
        "Realiza o sonho da casa própria é mais simples do que você imagina! Para isso, trouxemos um passo a passo com todas as facilidades que temos para financiar o seu imóvel.",
      passos_list: [
        {
          titulo: "1.Fale com a gente",
          texto:
            "Estamos a sua disposição em todas as redes sociais, por telefone e no chat aqui do site.",
          link: "",
        },
        {
          titulo: "2. Defina seu imóvel",
          texto:
            "De acordo com a sua região, vamos te apresentar os empreendimentos disponíveis e suas qualidade para que você escolha o imóvel ideal.",
          link: "",
        },
        {
          titulo: "3. Realize uma simulação",
          texto:
            "Confira como ficará o financiamento do seu futuro lar com nosso simulador, de forma simples e rápida, em apenas 3 passos.",
          link: "https://page.realizaconstrutora.com.br/simulador",
        },
        {
          titulo: "4. Utilize seu FGTS",
          texto:
            "Assim que tiver com todos os documentos necessários de fácil acesso, nossos corretores especializados irão, junto com você, solicitar a autorização do uso do FGTS para compra de imóvel",
          link: "",
        },
        {
          titulo: "5. Solicite aprovação do financiamento",
          texto:
            "Depois de todas as etapas anteriores concluídas, o corretor envia seus documentos solicitando a aprovação do financiamento para a compra do imóvel.",
          link: "",
        },
        {
          titulo: "6. Assine o contrato",
          texto:
            "E, ficando cada vez mais perto da realização do seu sonho, depois da aprovação, é chegada a hora da assinatura do contrato.",
          link: "",
        },
        {
          titulo: "7. Dê início a uma nova etapa da sua vida!",
          texto:
            "Agora é acompanhar a construção do seu sonho, aguardar a entrega das chaves e registrar esse momento tão esperado.",
          link: "",
        },
      ],
    },
    porque: {
      titulo: "Por que comprar com Realiza?",
      descricao: `45 anos abraçando o compromisso de realizar sonhos  
                  Mais de 37 mil imóveis entregues  
                  Sempre trabalhando com ética, transparência e respeito  
                  Presente em 5 estados do Brasil: MG, GO, RJ, SP, MS e ES  
                  Mais de 3 milhões de m² construídos`,
      imagem: { url: "/images/familia2.png" },
    },
    duvidas: {
      titulo: "Dúvidas frequentes",
      qual: [
        {
          titulo:
            "Qual a diferença do Minha Casa Minha Vida atual para o anterior?",
          descricao: `O programa do governo Minha Casa Minha Vida passou por uma reformulação. Ou seja, ele trouxe melhorias, mas manteve algumas regras, como a divisão por faixas de renda.`,
        },
        {
          titulo: "Qual é o valor máximo da minha parcela?",
          descricao: `O valor da parcela varia de acordo com sua renda e análise de crédito. Além disso, cada cidade possui um valor máximo de imóvel para enquadramento no programa.`,
        },
      ],
      poder: [
        {
          titulo:
            "Posso financiar um apartamento ou uma casa Realiza pelo Minha Casa Minha Vida?",
          descricao: `Sim! Você tem várias facilidades para conquistar seu imóvel, como subsídio do governo, uso do FGTS e possibilidade de composição de renda.`,
        },
        {
          titulo:
            "Posso participar do Minha Casa Minha Vida com o nome negativado?",
          descricao: `O programa em si não proíbe a participação de pessoas negativadas. Porém, recomendamos regularizar sua situação, pois restrições no SPC ou Serasa podem impedir a aprovação do financiamento pela Caixa, mesmo com comprovação de renda.`,
        },
      ],
    },
  };

  // DADOS RealizaPage
  const realizaPage = {
    seo: {
      titulo: data.SEO.title,
      descricao: data.SEO.description,
      imagem: strapiImg(data.SEO.image, "", true),
    },
    banner: {
      titulo: data.titulo,
      chamada: data.banner_internas.titulo,
      imagem: strapiImg(data.banner_internas.banner, "", true),
    },
    proposito: {
      titulo: data.secao01.titulo,
      texto: data.secao01.texto,
      imagem: strapiImg(data.secao01.imagem, "", true),
    },
    vocacao: {
      titulo: data.secao02.titulo,
      texto: data.secao02.texto,
      imagem: strapiImg(data.secao02.imagem, "", true),
    },
    missaoCompromisso: {
      titulo: data.secao03.titulo,
      texto: data.secao03.texto,
      imagem: strapiImg(data.secao03.imagem, "", true),
    },
    secaoDestaques: {
      titulo: data.secao_destaque.titulo,
      chamada: data.secao_destaque.chamada,
      icones: data.secao_destaque.icones,
    },
    secaoRecebaNovidades: {
      imagem: strapiImg(receiveNews.background_imagem, "", true),
      email: receiveNews.email_de_envio,
    },
  };

  return {
    props: {
      appLayout,
      realizaPage,
      casaVerdeAmarela,
    },
    revalidate: 60,
  };
}
